import { createSelector } from 'reselect';
import * as root from '../';
import * as fromRequestAsset from './request-asset.reducer';

export const getRequestAssetState = (state: root.State) => state.requestAsset;

export const getConflictingRequestsForRequestAssetId = createSelector(getRequestAssetState, fromRequestAsset.getConflictingRequestsForRequestAssetId);
export const getRequestAssetForAssetId = createSelector(getRequestAssetState, fromRequestAsset.getRequestAssetForAssetId);
export const getSelectedRequestAssetId = createSelector(getRequestAssetState, fromRequestAsset.getSelectedRequestAssetId);
